module.exports = __webpack_public_path__ + "static/media/Mano 4.9fc189a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 4.png
// module id = 186
// module chunks = 0